export * as PrimProductSmallDetail from "./product-small-detail";
